import React, { useState, useEffect } from "react";
import { Edit, Trash2, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "./Branch.css";

const url = process.env.REACT_APP_BACKEND_URL;

const BranchList = () => {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchBranches = async () => {
    try {
      const res = await axios.get(`${url}/api/branch`);
      setBranches(res.data.data || []);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to fetch branches");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this branch?")) {
      try {
        await axios.delete(`${url}/api/branch/${id}`);
        toast.success("Branch deleted successfully");
        fetchBranches();
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to delete branch");
      }
    }
  };

  if (loading) return <div className="loading">Loading branches...</div>;

  return (
    <div className="district-container">
      <div className="header">
        <h2>Branches List</h2>
        <button onClick={() => navigate("/addBranch")} className="add-button">
          <Plus size={16} /> Add Branch
        </button>
      </div>

      <div className="district-list">
        <table>
          <thead>
            <tr>
              <th>Branch Name</th>
              <th>District</th>
              <th>Department</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {branches.length === 0 ? (
              <tr>
                <td colSpan="4" className="no-data">
                  No branches found
                </td>
              </tr>
            ) : (
              branches.map((branch) => (
                <tr key={branch._id}>
                  <td>{branch.name}</td>
                  <td>{branch.district?.name || "N/A"}</td>
                  <td>{branch.department?.name || "N/A"}</td>
                  <td>
                    <div className="actions">
                      <button
                        onClick={() => navigate(`/branch/edit/${branch._id}`)}
                        className="edit"
                        title="Edit"
                      >
                        <Edit size={16} />
                      </button>
                      <button
                        onClick={() => handleDelete(branch._id)}
                        className="delete"
                        title="Delete"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BranchList;